import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid2";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layout/components/AppCard";
import Logo from "../../components/elements/Logo";
import Title from "../../components/elements/Title";
import { Styles } from "../../../config/design/styles";
import { useTranslation } from "react-i18next";
import MarketingChooseMobile from "./components/MarketingChooseMobile";
import MarketingVerifyOtp from "./components/MarketingVerifyOtp";
import MarketingVendorForm from "./components/MarketingVendorForm";

const PazarlamaPage = ({ classes }) => {
    const { t } = useTranslation();
    const [level, setLevel] = useState(1);
    const [rep, setRep] = useState(null);
    const [session, setSession] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [level]);

    const handleVerified = (data) => {
        setSession(data);
        sessionStorage.setItem("marketing_rep_id", data.rep_id);
        sessionStorage.setItem("marketing_session_token", data.session_token);
        setLevel(3);
    };

    const handleRepSelected = (data) => {
        setRep(data);
        setLevel(2);
    };

    return (
        <AppAnimate animation="transition.slideUpIn" delay={200} title={t("marketingPageTitle")}>
            <div className={classes.marketingPageInner}>
                <AppCard
                    title={
                        <Logo old_logo parentStyle={{ textAlign: "center", width: "100%" }} style={{ width: 150 }} />
                    }
                    contentStyle={{
                        paddingLeft: 16,
                        paddingRight: 16,
                        paddingBottom: 24,
                        overflow: "visible",
                    }}
                >
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item size={12} sx={{ mt: { xs: 1, sm: 2 }, mb: { xs: 1, sm: 2 } }}>
                            <Title color="field" align="left">
                                {t("marketingPageTitle")}
                            </Title>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>
                                {t("marketingPageDesc")}
                            </Typography>
                        </Grid>
                        <Grid item size={12}>
                            {level === 1 && (
                                <MarketingChooseMobile setRep={handleRepSelected} setNextLevel={() => setLevel(2)} />
                            )}
                            {level === 2 && !!rep && (
                                <MarketingVerifyOtp rep={rep} onVerified={handleVerified} onBack={() => setLevel(1)} />
                            )}
                            {level === 3 && !!session && (
                                <MarketingVendorForm session={session} onSuccess={() => setLevel(4)} />
                            )}
                            {level === 4 && (
                                <Box textAlign="center" py={4}>
                                    <Title color="primary">{t("marketingFormSuccessTitle")}</Title>
                                    <Typography sx={{ mt: 2 }}>{t("marketingFormSuccessDesc")}</Typography>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </AppCard>
            </div>
        </AppAnimate>
    );
};

export default withStyles(Styles)(PazarlamaPage);
